import styled from "styled-components";



const Buttonlink = styled.a(({ theme }) => {
  return {
    "&&.MuiButton-root": {
    },
  };
})

const Container = styled.div(({ theme }) => {
 return{
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
 }
})



const Styles = {
  Buttonlink,
  Container
};

export default Styles;
